import store from '@/store'

const guides: string[] = [
  'STEPS_00000_SigninPage',
  'STEPS_01001_ItemSearchPage',
  'STEPS_01001_ItemSearchWithCategoryPage',
  'STEPS_01002_ItemDetailPage',
  'STEPS_02000_CartPage_NoItem',
  'STEPS_02000_CartPage',
  'STEPS_03000_OrderRequestPage_Confirm',
  'STEPS_03000_OrderRequestPage',
  'STEPS_04000_MyPage',
  'STEPS_06000_OrderRequestListPage_NoOrderRequest',
  'STEPS_06000_OrderRequestListPage',
  'STEPS_07000_OrderListPage_NoOrder',
  'STEPS_07000_OrderListPage',
  'STEPS_10000_AccountPage',
]

export function useTourguideFunc() {

  /**
   * 
   * @return
   */
  function clearLocalStorage() {
    guides.forEach((guide) =>{
      localStorage.removeItem('vjt-' + guide)
    })
    return true
  }

  return {
    clearLocalStorage,
  }
}
